import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { Ref } from '@vue/composition-api';
import { computed } from '@vue/composition-api';
import { DateTime } from 'luxon';
import { useDocumentHits } from './document-hits.composable';

export const useDocumentHitsData = (showAll: Ref<boolean>) => {
  const currentPeriod = {
    from: DateTime.now().toUTC().startOf('month').toMillis(),
    to: DateTime.now().toUTC().endOf('month').toMillis(),
  };
  const previousPeriod = {
    from: DateTime.now().toUTC().minus({ month: 1 }).startOf('month').toMillis(),
    to: DateTime.now().toUTC().minus({ month: 1 }).endOf('month').toMillis(),
  };

  const {
    data: previousData,
    isSuccess: previousIsSuccess,
    isLoading: previousIsLoading,
  } = useDocumentHits(previousPeriod, showAll);
  const {
    data: currentData,
    isSuccess: currentIsSuccess,
    isLoading: currentIsLoading,
  } = useDocumentHits(currentPeriod, showAll);

  const value = computed(() => {
    if (!currentData.value) {
      return `${0}%`;
    }
    const value = Math.round((currentData.value.count / currentData.value.value) * 100);
    return `${value || 0}%`;
  });

  const subValue = computed(() => {
    if (!previousData.value) {
      return `${0}%`;
    }
    const value = Math.round((previousData.value.count / previousData.value.value) * 100);
    return `${value || 0}%`;
  });

  const valueTitle = computed(() => {
    if (!currentData.value) {
      return `${0}/${0} ${t('Deals')}`;
    }
    return `${currentData.value.count}/${currentData.value.value} ${t('Deals')}`;
  });

  return {
    isLoading: previousIsLoading || currentIsLoading,
    isSuccess: previousIsSuccess && currentIsSuccess,
    value,
    subValue,
    valueTitle,
  };
};
